import { createVNode, mergeProps } from "vue";
export default {
  name: 'ApertureIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-aperture"
    }, { ...attrs
    }), [createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }), createVNode("line", {
      "x1": "14.31",
      "y1": "8",
      "x2": "20.05",
      "y2": "17.94"
    }), createVNode("line", {
      "x1": "9.69",
      "y1": "8",
      "x2": "21.17",
      "y2": "8"
    }), createVNode("line", {
      "x1": "7.38",
      "y1": "12",
      "x2": "13.12",
      "y2": "2.06"
    }), createVNode("line", {
      "x1": "9.69",
      "y1": "16",
      "x2": "3.95",
      "y2": "6.06"
    }), createVNode("line", {
      "x1": "14.31",
      "y1": "16",
      "x2": "2.83",
      "y2": "16"
    }), createVNode("line", {
      "x1": "16.62",
      "y1": "12",
      "x2": "10.88",
      "y2": "21.94"
    })]);
  }

};